export const GeneralStyle = {
  title12: "12px",
  title14: "14px",
  title16: "16px",
  title18: "18px",
};
export const EverGreenStyle = {
  ...GeneralStyle,
  logoWhite: "logoSinglifeWhite",
  logoRed: "logoSinglifeRed",
  colors: {
    primary: "#0A544F",
    white: "#ffffff",
    secondary: "#616161",
    faded: "#AEC5C6",
    error: {
      background: "#ffe9e9",
      text: "#990005",
    },
    grey: {
      100: "#aaaaaa",
      200: "#f9f9f9",
      300: "#c9c9c9",
      400: "#6f6d80",
      500: "#434343",
      600: "#eeeeee",
      700: "#f5f5f5",
      800: "#333333",
      900: "#999999",
      1000: "#D8D8D8",
      1100: "#616161",
      1200: "#8A8988",
      1300: "#FAFAFA",
      1400: "#434343",
      1500: "#C9C9C9",
      1600: "#C4C4C4",
    },
    blue: {
      100: "#ecf8ff",
      200: "#004fb6",
      300: "#44c0ff",
      400: "#1a61bd",
      500: "#f5f8fc",
      600: "#dce6f4",
    },
    green: {
      100: "#4f9f31",
      200: "#4ca02b",
    },
    red: {
      100: "#f8e9e9",
      200: "#bd2624",
      300: "#87378e",
      400: "#d90007",
      500: "#d90006",
      600: "#c80a00",
    },
  },
  fontFamily: "'Open Sans', -apple-system, system-ui, sans-serif",
  fontSize: {
    xs: 12,
    title: 32, // 42
    smallTitle: 28,
    subtitle: 24, // 28
    title18: "18px",
    label: 20,
    text: 16,
    description: 14,
    bigTitle: 42,
    bigSub: 26,
  },
  fontSizeTablet: {
    title: 42,
    smallTitle: 28,
    subtitle: 28,
    label: 20,
    text: 16,
    description: 14,
    bigTitle: 42,
    bigSub: 26,
  },
  iconSize: {
    xsm: 14,
    sm: 16,
    md: 25,
    lg: 35,
    dlg: 65,
  },
};

export const EVTheme = {};
